import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as LZString from 'lz-string';


if (environment.production) {
  enableProdMode();
}


try {

const originalSetItem = Storage.prototype.setItem;

Storage.prototype.setItem = function(key, value) {

  if (key === 'courseByTeacherData' || key === 'courseByTeacherDataDateWise') {
    try {
      value = LZString.compressToUTF16(value);
    } catch (e) {
      console.error("Compression error", e);
    }
  }

  return originalSetItem.call(this, key, value);
};

} catch (e){
  console.log("Main.ts setitem error", e)
}


try {

const originalGetItem = Storage.prototype.getItem;

Storage.prototype.getItem = function(key) {

  const value = originalGetItem.call(this, key);

  if ((key === 'courseByTeacherData' || key === 'courseByTeacherDataDateWise') && value) {
    try {
      return LZString.decompressFromUTF16(value);
    } catch (e) {
      console.error("Decompression error", e);
      return value;
    }
  }

  return value;
};

} catch (e){
  console.log("Main.ts getitem error", e)
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
